import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MediaSize from '@adv-mt/mt-media-size'

const BASE_CLASS = 'mt-TechnicalDetailsVehicleSize'
const unit = 'mm'

export const VehicleSize = ({width, height, length}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const appName = config.get('APP_NAME').toLowerCase()
  const hasWidth = Boolean(width)
  const hasHeight = Boolean(height)
  const hasLength = Boolean(length)
  const imageSrcSide = `https://s.ccdn.es/images/${appName}/new-vehicle/frame-vehicle-side.svg`
  const imageSrcFront = `https://s.ccdn.es/images/${appName}/new-vehicle/frame-vehicle-front.svg`
  return (
    <div className={BASE_CLASS}>
      {hasLength && (
        <div className={`${BASE_CLASS}-item ${BASE_CLASS}-side`}>
          <MediaSize width={length} unit={unit}>
            <div className={`${BASE_CLASS}-image`}>
              <AtomImage src={imageSrcSide} alt="..." />
            </div>
          </MediaSize>
        </div>
      )}
      {hasWidth && hasHeight && (
        <div className={`${BASE_CLASS}-item ${BASE_CLASS}-front`}>
          <MediaSize width={width} height={height} unit={unit}>
            <div className={`${BASE_CLASS}-image`}>
              <AtomImage src={imageSrcFront} alt="..." />
            </div>
          </MediaSize>
        </div>
      )}
    </div>
  )
}

VehicleSize.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  length: PropTypes.string
}
